import clsx from "clsx"
import { ProductImageSize, toProductImageCdnUrl } from "src/utilities/productImages"
import { ResponsiveImage } from "../unstyled/ResponsiveImage"

export type ProductListItemImageProps = {
  src: string
  alt: string
  className?: string
}

export const ProductListItemImage = ({ src, alt, className }: ProductListItemImageProps) => {
  return (
    <ResponsiveImage
      src={toProductImageCdnUrl(src, ProductImageSize.Large)}
      alt={"Abbildung: " + alt} // avoid https://dequeuniversity.com/rules/axe/4.9/image-redundant-alt
      width={ProductImageSize.Large}
      height={ProductImageSize.Large}
      className={clsx("m-0! aspect-square w-full shrink-0 rounded-3xl object-contain", className)}
    />
  )
}
